import {useAppDispatch, useAppSelector} from "../../../../redux/hooks";
import {RootState} from "../../../../redux/store";
import React, {useEffect} from 'react';
import {user_to_adventure} from '../../../../redux/slices/adventure/adventureType';
import {KampagneMask} from '../../Kampagne/KampagneMask';
import Button from '../../../../Atoms/Button';
import {PlayArrowSharp} from '@mui/icons-material';
import {useLazyQuery, useQuery, useSubscription} from '@apollo/client';
import {GetCharacter4User} from '../../../../GraphQL/CharacterQueries';
import {ActiveContent} from '../../../../redux/slices/content/contentType';
import {setCharacter} from '../../../../redux/slices/character/characterSlice';
import {setIsAppLoading} from '../../../../redux/slices/content/contentSlice';
import {toast} from 'react-toastify';
import {emptyCharacter} from "../../../../Helper/Constants";

export const AdventureCharacterSheetTab = (props: {
    selectedPlayer: user_to_adventure | null;
    setSelectedPlayer: (player: user_to_adventure | null) => void;
}) => {
    const adventure = useAppSelector((state: RootState) => state.adventure);
    const dispatch = useAppDispatch();

    const [
        getCharacterSheet, {
            data: characterData,
            error: characterError,
            loading: characterLoading
        } ] = useLazyQuery(GetCharacter4User)

    useEffect(() => {
        if (characterLoading) {
            dispatch(setIsAppLoading({isAppLoading: true, loadingText: 'Charakterbogen wird geladen...'}))
        } else {
            dispatch(setIsAppLoading({isAppLoading: false, loadingText: ''}))
        }
    }, [ characterLoading ])

    useEffect(() => {
        if (characterError) {
            toast('Fehler beim Laden des Charakterbogens')
        }
    }, [ characterError ])

    const selectPlayer = async (player: any) => {
        const characterSheet = await getCharacterSheet({
            variables: {
                userId: Number(player.User.userId),
                adventureId: Number(adventure.adventureId)
            },
            fetchPolicy: 'network-only'
        })
        if (characterSheet) {
            if (characterSheet.data) {
                dispatch(setCharacter({
                    characterName: characterSheet.data.getCharacters4User.characterName,
                    characterId: Number(characterSheet.data.getCharacters4User.characterId),
                    characterLevel: characterSheet.data.getCharacters4User.characterLevel,
                    characterExp: characterSheet.data.getCharacters4User.characterExp,
                    character_to_class: characterSheet.data.getCharacters4User.character_to_class,
                    Race: characterSheet.data.getCharacters4User.Race,
                    Subrace: characterSheet.data.getCharacters4User.Subrace,
                    CharacterSheet: characterSheet.data.getCharacters4User.CharacterSheet
                }))

                props.setSelectedPlayer(player)
            }
        }
    }

    const deselectUser = () => {
        dispatch(setCharacter(emptyCharacter))

        props.setSelectedPlayer(null)
    }

    const renderOneUserSelect = (player: user_to_adventure) => {
        const charSheet = player.User.Character[0] ? player.User.Character[0].CharacterSheet : null;
        return (
            <div className='player-container' onClick={async () => await selectPlayer(player)}>
                <div>                
                    {player.User.userName}
                </div>
                { charSheet !== null &&
                    (
                        <div>
                            HP: {player.User.Character[0].CharacterSheet?.currentHitpoints} / {player.User.Character[0].CharacterSheet?.lifepoints}
                        </div>
                    )
                }
                { charSheet === null &&
                    (
                        <div>
                            Noch kein Charakter erstellt
                        </div>
                    )
                }
            </div>
        )
    }

    const renderUserSelect = () => {
        const html = [];
        for (const player of adventure.user_to_adventure) {
            html.push(renderOneUserSelect(player))
        }

        return html;
    }

    return (
        <div className='player-overview'>
            {props.selectedPlayer === null && renderUserSelect()}
            { props.selectedPlayer !== null &&
                <KampagneMask userId={ props.selectedPlayer.User.userId } getBack={ deselectUser } />
            }
        </div>
    )
}